module.exports = __webpack_public_path__ + "img/symbol_0.d68ed651.png";